// extracted by mini-css-extract-plugin
export var dropdown = "_vh-0";
export var imageWrapper = "_vh-3";
export var itemNameContainer = "_vh-1";
export var productImage = "_vh-2";
export var spinnerWrapper = "_vh-4";